import { CircleDollarSign, ReceiptText } from "lucide-react";
import type { Order } from "../../account";

export function OrderHistory({ orders, showEmpty = false }: { orders: Order[]; showEmpty?: boolean }) {
  if (!orders.length && !showEmpty) return null;
  const status: Record<string, string> = {
    created: "Luotu",
    payment_pending: "Odottaa maksua",
    paid: "Maksettu",
    cancelled: "Peruttu",
    payment_failed: "Maksu epäonnistui",
    refund_pending: "Palautus kesken",
    partially_refunded: "Osittain palautettu",
    refunded: "Palautettu",
  };
  return (
    <section className="account-panel">
      <span className="eyebrow">Tilaukset</span>
      <h2>Ostot ja maksujen tila</h2>
      {orders.length ? <div className="account-item-list">
        {orders.map((order) => (
          <article key={order.id}>
            <CircleDollarSign />
            <div>
              <b>
                {order.order_number} · {order.seller_name}
              </b>
              <span>
                {(order.total_amount / 100).toLocaleString("fi-FI", {
                  style: "currency",
                  currency: order.currency,
                })}{" "}
                · {status[order.status] ?? order.status}
              </span>
            </div>
          </article>
        ))}
      </div> : <div className="account-empty compact"><ReceiptText/><h3>Ei vielä tilauksia</h3><p>Lupava.fi:n kautta ostetut lupatuotteet, kuitit ja maksujen tila tulevat tähän.</p><a href="/#permits">Tutustu lupatuotteisiin</a></div>}
    </section>
  );
}

